import _ from 'underscore'
import API from 'core/api'

export default {

	namespaced: true,

	modules: {},

	state: {},

	getters: {},

	mutations: {},

	actions: {

		generic: function(context, data) {

			data = data || {}
			data.params = data.params || {}

			return new Promise(function(resolve, reject) {

				API.request(data.url, data.params, true).then(function(json) {

					// add reference data
					context.commit('data/users/add', json.data.users, { root: true })
					context.commit('data/games/add', json.data.games, { root: true })
				
					// first page, replace lists
					if (json.page === 1) {

						context.commit('page/lists/set', json.lists, { root: true })

					// otherwise paginate
					} else {

						_.each(json.lists, function(item) {

							context.commit('page/lists/push', item, { root: true })

						})

					}

					context.commit('ready', null, { root: true })

					resolve(json)

				}, function(json) {

					reject(json)

				})

			})		

		},

		users: function(context, params) {

			params.filter = context.rootGetters['filter/lists']

			return context.dispatch('generic', {
				params: params,
				url: 'users/lists'
			})	
			
		},

		groups: function(context, params) {

			params.filter = context.rootGetters['filter/lists']

			return context.dispatch('generic', {
				params: params,
				url: 'groups/lists'
			})	
			
		},

		buddies: function(context, params) {

			params.filter = context.rootGetters['filter/lists']

			return context.dispatch('generic', {
				params: params,
				url: 'buddies/lists'
			})	
			
		}

	}

}